import React, { FC } from "react";
import { LocalizationProvider } from "@deere/isg.component-library";
import { Translations } from "@deere/translation-service";

type AppHomeProps = {
  children: React.ReactElement;
  translations: Translations | undefined;
};

export const AppHome: FC<AppHomeProps> = ({ children, translations }: AppHomeProps) => {
  return <LocalizationProvider translations={translations}>{children}</LocalizationProvider>;
};
